// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class HybridEnrollmentHistoryModel {
    static getAttributeTypeMap() {
        return HybridEnrollmentHistoryModel.attributeTypeMap;
    }
}
HybridEnrollmentHistoryModel.discriminator = undefined;
HybridEnrollmentHistoryModel.additionalProperties = false;
HybridEnrollmentHistoryModel.attributeTypeMap = [
    {
        "name": "bin",
        "baseName": "bin",
        "type": "string"
    },
    {
        "name": "sponsorNumber",
        "baseName": "sponsorNumber",
        "type": "string"
    },
    {
        "name": "groupNumber",
        "baseName": "groupNumber",
        "type": "string"
    },
    {
        "name": "cardAlternateIDs",
        "baseName": "cardAlternateIDs",
        "type": ""
    },
    {
        "name": "enrollmentId",
        "baseName": "enrollmentId",
        "type": "string"
    },
    {
        "name": "claimEligibilityDate",
        "baseName": "claimEligibilityDate",
        "type": "Date"
    },
    {
        "name": "enrollmentStartDate",
        "baseName": "enrollmentStartDate",
        "type": "Date"
    },
    {
        "name": "enrollmentEndDate",
        "baseName": "enrollmentEndDate",
        "type": "Date"
    },
    {
        "name": "enrollmentStatus",
        "baseName": "enrollmentStatus",
        "type": "string"
    },
    {
        "name": "totalBenefitAmount",
        "baseName": "totalBenefitAmount",
        "type": "number"
    },
    {
        "name": "remainingBenefitAmount",
        "baseName": "remainingBenefitAmount",
        "type": "number"
    },
    {
        "name": "totalPaidAmount",
        "baseName": "totalPaidAmount",
        "type": "number"
    },
];
//# sourceMappingURL=hybridEnrollmentHistoryModel.js.map